import React from 'react';
import Modal, { ModalProps } from '@app/component/overlays/modal/Modal';
import { SubmitButton } from '@app/site/_form/button/SubmitButton';
import useAppForm from '@app/site/_form';
import SearchHotelWithinRadiusResult from '@app/model/flexi_sets/SearchHotelWithinRadiusResult';
import * as z from 'zod/v4';
import {
	useSaveOrCreateCompanyHotelCompetitorsGroupMutation,
} from '@app/model/company_hotel/service/CompanyHotelServiceHooks';
import useToaster from '@app/component/overlays/toaster/ToasterHook';
import { useNavigate } from 'react-router-dom';
import SaveOrCreateCompetitorsGroupInput from '@app/model/company_hotel/input/SaveOrCreateCompetitorsGroupInput';


type SaveOrCreateSetPageModalProps = ModalProps & {
	companyHotelId: number
	competitorId: number | undefined;
	competitorsGroupName: string;
	flexiSetHotels: SearchHotelWithinRadiusResult[]
}

const SaveOrCreateSetPageModal = React.memo(
	function SaveOrCreateSetPageModal({
																			companyHotelId,
																			competitorId,
																			competitorsGroupName,
																			flexiSetHotels,
																			...props
																		}: SaveOrCreateSetPageModalProps) {
		const toaster = useToaster();
		const navigate = useNavigate();

		const defaultFormValues: SaveOrCreateCompetitorsGroupInput = {
			companyHotelId: companyHotelId,
			competitorIds: flexiSetHotels.map(h => h.id),
			competitorsGroupName: competitorsGroupName,
			competitorId: competitorId,
		};

		const InputValidation = z.object({
			companyHotelId: z.number(),
			competitorId: z.number().optional(),
			competitorsGroupName: z.string().nonempty('Name is required'),
			competitorIds: z.array(z.number()).min(1, 'Add at least one listing to the Set before saving!').max(30, 'You can add up to 30 listings to the Set!')
		});

		const saveOrCreateGroupMutation = useSaveOrCreateCompanyHotelCompetitorsGroupMutation({
			onSuccess: () => {
				navigate('/secured/rateshopper/rates/flexi-sets');
				toaster.success('Flexi Set', 'Flexi Set saved successfully!');
			},
		});

		const form = useAppForm({
			defaultValues: defaultFormValues,
			validators: {
				onChange: InputValidation,
			},
			onSubmit: ({ value }) => saveOrCreateGroupMutation.mutateAsync({ input: value }).catch((e) => {
			}),
		});

		return <form.AppForm>
			<form onSubmit={
				(e) => {
					e.preventDefault();
					e.stopPropagation();
				}
			}>
				<Modal {...props} title={`${competitorId ? 'Edit' : 'Create'} Flexi Set`} actions={
					<SubmitButton state="primary">Save</SubmitButton>
				}>
					<form.AppField name="competitorsGroupName"
												 children={(field) => <field.TextField label="Name"
																															 placeholder="Insert Flexi Set name" />} />
				</Modal>
			</form>
		</form.AppForm>;
	},
);

export default SaveOrCreateSetPageModal;